export class Time {
  private _minutes: number = 0;

  public static minutes(value: number): Time {
    const time = new Time();
    time.minutes = value;
    return time;
  }

  private set minutes(value: number) {
    this._minutes = value;
  }

  public format() {
    const date = new Date(this._minutes * 60 * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const timeString =
      `${hours.toString().padStart(2, "0")}` +
      ":" +
      `${minutes.toString().padStart(2, "0")}`;

    return timeString;
  }
}
